// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2VBHh","checkboxCol":"Table_checkboxCol__Wu-6E","emailCol":"Table_emailCol__2PrwM","actionCol":"Table_actionCol__2-g1x"};